import React, { Component } from "react";
import axios from "axios";
import api from "../api";
import Dialog from "@material-ui/core/Dialog";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Slide from "@material-ui/core/Slide";
import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Toolbar from "@material-ui/core/Toolbar";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import MenuItem from "@material-ui/core/MenuItem";
import InputAdornment from "@material-ui/core/InputAdornment";
import MediaFile from "../../../components/common/MediaFile";
import MenuActions from "../MenuActions";
import Checkbox from "@material-ui/core/Checkbox";
import NumberFormat from "react-number-format";
import Input from "@material-ui/core/Input";
import InputMask from "react-input-mask";
import Select from "@material-ui/core/Select";
import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@material-ui/core";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <InputMask
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        /[A-C,a,c]/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/
      ]}
      //maskPlaceholder={'0'}
      //showMask
      alwaysShowMask={false}
      autoComplete={false}
      showMask={false}
    />
  );
}

const useStyles = theme => ({
  root: {
    flexGrow: 1,
    width: "100%"
  },
  appBar: {
    position: "relative"
  },
  title: {
    marginLeft: "2rem",
    flex: 1,
    color: "white"
  },
  paper: {
    padding: "2rem",
    textAlign: "center"
  },
  checkedIcon: {
    width: 16,
    height: 16
  },
  option: {
    fontWeight: 600,
    fontSize: "0.75rem"
  },
  typography: {
    fontSize: "0.75rem"
  },
  select: {
    marginTop: "8px",
    marginRight: "8px"
  },
  tableCell: {
    padding: "8px 4px 8px 4px",
    border: "1px solid #dee2e6"
  }
});

class Vouchers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      vouchers: [],
      voucher_realted: {},
      payment_deals: [],
      dialog: { open: false },
      snackbar: { open: false, severity: "" },
      action: "",
      work_order_tasks_count: 0,
      payment_deal: 0,
      payment_deal_hansa_code: "",
      provider_payment_deal: 0,
      saving: false,
      reject_dialog: { open: false },
      voucher: {
        hansa_voucher_confirmed: false,
        voucher_total_s_iva_price: 0,
        created_at: new Date().toISOString().slice(0, 10),
        tasks: [],
        can_edit: true
      },
      voucher_types: [],
      files: [],
      providers: [],
      budgets: [],
      saving: false
    };
  }

  async componentDidMount() {
    var work_order_id = this.props.work_order.id;
    var voucher = this.state.voucher;
    var work_order_tasks_count = this.props.tasks.tasks.tasks.filter(
      task => task.id > 0
    ).length;
    await this.getVouchersTaskAvalaible(work_order_id);
    await this.getVouchers(work_order_id);
    await this.getVoucherTypes();
    await this.getPaymentsDeals();
    await this.getProviders(this.props.work_order.id);
    this.setState({
      voucher: voucher,
      work_order_tasks_count: work_order_tasks_count
    });
  }

  getVouchersTaskAvalaible = id => {
    const token = localStorage.getItem("userToken");
    axios
      .get(api.vouchers().tasks_available(id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var voucher = this.state.voucher;
        voucher.tasks = res.data;
        this.setState({ voucher: voucher });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getVoucher = async id => {
    const token = localStorage.getItem("userToken");
    axios
      .get(api.vouchers().get(id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(async res => {
        var voucher = this.state.voucher;
        voucher = res.data[0];
        voucher.tasks[0].checked = true;
        voucher.contact_id = parseInt(res.data[0].contact.id);
        voucher.voucher_type_id = parseInt(res.data[0].voucher_type_id);
        voucher.all_tasks =
          res.data[0].all_tasks === "1" || res.data[0].all_tasks === 1
            ? true
            : false;
        voucher.tasks = res.data[0].tasks;
        voucher.media_url = "";
        if (voucher.media.length > 0)
          voucher.media_url = await this.getMediaUrl(voucher.media[0].id);
        var payment_deal_hansa_code = this.state.payment_deal_hansa_code;
        payment_deal_hansa_code = voucher.custom_payment_deal
          ? voucher.custom_payment_deal
          : payment_deal_hansa_code;
        this.setState({
          voucher: voucher,
          payment_deal_hansa_code: payment_deal_hansa_code
        });
        this.doSubtotals();
      })
      .catch(err => {
        console.log(err);
      });
  };

  getVoucherByNumber = async number => {
    const token = localStorage.getItem("userToken");
    const params = {
      number: number,
      contact_id: this.state.voucher.contact_id
    };
    await axios
      .get(api.vouchers().getByNumber(), {
        headers: { Authorization: `Bearer ${token}` },
        params: params
      })
      .then(res => {
        var voucher_realted = this.state.voucher_related;
        voucher_realted = res.data[0];
        var voucher = this.state.voucher;
        voucher.reception_date = voucher_realted.reception_date;
        voucher.voucher_date = voucher_realted.voucher_date;
        voucher.due_date = voucher_realted.due_date;
        voucher.voucher_total_s_iva_price =
          voucher_realted.voucher_total_s_iva_price;
        this.setState({ voucher_realted: voucher_realted });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getVouchers = id => {
    const token = localStorage.getItem("userToken");
    axios
      .get(api.work_order().vouchers(id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var vouchers = res.data;
        this.setState({ vouchers: vouchers });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getProviders = () => {
    var providers = [];
    var budgets = [];
    var voucher = this.state.voucher;
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.work_order().get(this.props.work_order.id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var data = res.data.budgets;
        data.map((val, idx) => {
          if (val.state === "VERIFICADO" || val.state === "PARA FACTURAR") {
            providers.push({
              id: val.provider.id,
              business_name: val.provider.business_name,
              contact_id: val.provider.contact,
              payment_deal: val.provider.payment_deal
            });
            budgets.push({ id: val.id, number: val.number });
          }
        });

        if (providers.length > 0) {
          voucher.contact_id = providers[0].contact_id;
        }

        if (budgets.length > 0) {
          voucher.budget_id = budgets[0].id;
        }
        var payment_deal = providers[0]
          ? providers[0].payment_deal
            ? providers[0].payment_deal
            : 0
          : 0;
        this.setState({ providers: providers, budgets: budgets });
        this.setState({ voucher: voucher });
        this.setState({
          payment_deal: payment_deal,
          provider_payment_deal: payment_deal,
          payment_deal_hansa_code: payment_deal
        });
      })
      .catch(err => {
        console.log(err);
      });
    /*
		this.props.work_order.budgets.map((val, idx)=>{
    		if (val.state === 'APROBADO' || val.state === 'PARA FACTURAR'){
    			providers.push({id: val.provider.id, business_name: val.provider.business_name, contact_id: val.provider.contact, payment_deal: val.provider.payment_deal})
    			budgets.push({id: val.id, number: val.number})
    		}
    	})*/
  };

  getVoucherTypes = () => {
    const token = localStorage.getItem("userToken");
    var voucher = this.state.voucher;
    axios
      .get(api.voucher_types, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        var voucher_types = res.data;
        if (voucher_types.length > 0) {
          if (this.props.default_voucher_type_id) {
            voucher.voucher_type_id = this.props.default_voucher_type_id;
          } else {
            var voucher_type = voucher_types.filter(
              v => v.name === "Factura"
            )[0];
            voucher.voucher_type_id = voucher_type ? voucher_type.id : "";
          }
        }
        this.setState({ voucher_types: voucher_types, voucher: voucher });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getPaymentsDeals = () => {
    const token = localStorage.getItem("userToken");
    axios
      .get(api.payment_deals, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        this.setState({ payment_deals: res.data });
      })
      .catch(err => {
        console.log(err);
      });
  };

  handleDialog = async e => {
    e.preventDefault();
    var dialog = this.state.dialog;
    dialog.open = !dialog.open;
    this.setState({ dialog: dialog });
    if (!dialog.open) {
      await this.getVouchers(this.props.work_order.id);
      await this.getVouchersTaskAvalaible(this.props.work_order.id);
      var voucher = { tasks: [] };
      this.setState({ voucher: voucher });
    }
  };

  handleSnackbar = e => {
    e.preventDefault();
    var snackbar = this.state.snackbar;
    snackbar.open = !snackbar.open;
    this.setState({ snackbar: snackbar });
  };

  handleMenuAction = async (e, action, id) => {
    e.preventDefault();
    e.stopPropagation();
    var voucher_id = this.state.vouchers[id].id;
    switch (action) {
      case "Descargar":
        this.downloadVoucher(voucher_id);
        return;
    }
  };

  downloadVoucher = id => {
    var formData = new FormData();
    const token = localStorage.getItem("userToken");
    axios
      .post(api.vouchers().downloadSapVoucher(id), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        },
        responseType: "blob"
      })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.setAttribute("download", "comprobante_" + id + ".pdf");
        link.setAttribute("href", url);
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
  };

  handleApproveVoucher = id => {
    if (this.state.saving) return;
    this.setState({ saving: true });
    var formData = new FormData();
    formData.set("voucher[id]", id);
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .post(api.vouchers().approve(id), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        var snackbar = this.state.snackbar;
        snackbar.open = true;
        snackbar.success_message = "Comprobante aprobado con éxito";
        snackbar.severity = "success";
        this.getVouchers(this.props.work_order.id);
        this.props.onUpdateWorkOrderState();
        this.setState({ snackbar: snackbar, saving: false });
      })
      .catch(function(error) {
        console.log(error);
        var error_message = "Ha ocurrido un error al cargar el presupuesto.";
        var errors = error.response.data;
        if (errors.errors) {
          if (errors.errors.status_code !== 404) {
            var keys = Object.keys(errors.errors);
            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              var key_errors = errors.errors[key];
              error_message = "";
              key_errors.map((val, idx) => {
                error_message = error_message.concat(val).concat(" ");
              });
            }
          } else {
            error_message = error_message
              .concat(" ")
              .concat(errors.errors.message);
          }
        }
        var snackbar = {
          open: true,
          success_message: error_message,
          severity: "error"
        };
        self.setState({ snackbar, saving: false });
      });
  };

  handleForceAttachment = id => {
    var formData = new FormData();
    formData.set("voucher[id]", id);
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .post(api.vouchers().forceattachment(id), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(res => {
        var snackbar = this.state.snackbar;
        snackbar.open = true;
        snackbar.success_message = "Se adjuntó con éxito";
        snackbar.severity = "success";
        this.setState({ snackbar: snackbar });
      })
      .catch(error => {
        var error_message = "";
        var errors = error.response.data;
        if (errors.errors) {
          if (errors.errors.status_code !== 404) {
            var keys = Object.keys(errors.errors);
            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              var key_errors = errors.errors[key];
              error_message = "";
              key_errors.map((val, idx) => {
                error_message = error_message.concat(val).concat(" ");
              });
            }
          } else {
            error_message = error_message
              .concat(errors.errors.message)
              .concat(" ");
          }
        }
        if (error_message === "") {
          error_message =
            "Ha ocurrido un error al adjuntar el archivo. Contacte a su administrador";
        }
        var snackbar = {
          open: true,
          success_message: error_message,
          severity: "error"
        };
        this.setState({ snackbar });
      });
  };
  handleCancelVoucher = id => {
    const token = localStorage.getItem("userToken");
    var id = id;
    axios
      .delete(
        api.vouchers().delete(id),
        { headers: { Authorization: `Bearer ${token}` } },
        { params: { id: id } }
      )
      .then(res => {
        var snackbar = this.state.snackbar;
        snackbar.open = true;
        snackbar.success_message = "Comprobante anulado con éxito";
        snackbar.severity = "success";
        this.getVouchers(this.props.work_order.id);
        this.setState({ snackbar: snackbar });
      })
      .catch(error => {
        var error_message = "";
        var errors = error.response.data;
        if (errors.errors) {
          if (errors.errors.status_code !== 404) {
            var keys = Object.keys(errors.errors);
            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              var key_errors = errors.errors[key];
              error_message = "";
              key_errors.map((val, idx) => {
                error_message = error_message.concat(val).concat(" ");
              });
            }
          } else {
            error_message = error_message
              .concat(errors.errors.message)
              .concat(" ");
          }
        }
        if (error_message === "") {
          error_message =
            "Ha ocurrido un error al anular el comprobante. Contacte a su administrador";
        }
        var snackbar = {
          open: true,
          success_message: error_message,
          severity: "error"
        };
        this.setState({ snackbar });
      });
  };

  handleSubmit = e => {
    this.setState({ saving: true });
    e.preventDefault();
    var formData = new FormData();
    var voucher = this.state.voucher;
    var providers = this.state.providers;
    var i = 0;
    if (voucher.all_tasks) {
      formData.set(
        "voucher[" + i + "][work_order_id]",
        this.props.work_order.id
      );
      formData.set(
        "voucher[" + i + "][voucher_type_id]",
        voucher.voucher_type_id
      );
      formData.set(
        "voucher[" + i + "][number]",
        voucher.number ? voucher.number : ""
      );
      formData.set(
        "voucher[" + i + "][budget_id]",
        voucher.budget_id ? voucher.budget_id : ""
      );
      formData.set("voucher[" + i + "][contact_id]", providers[0].contact_id);
      formData.set(
        "voucher[" + i + "][workforce_s_iva_price]",
        voucher.subtotals.materials
      );
      formData.set(
        "voucher[" + i + "][materials_s_iva_price]",
        voucher.subtotals.workforce
      );
      formData.set(
        "voucher[" + i + "][total_s_iva_price]",
        voucher.subtotals.total
      );
      formData.set(
        "voucher[" + i + "][due_date]",
        voucher.due_date ? voucher.due_date : ""
      );
      formData.set(
        "voucher[" + i + "][reception_date]",
        voucher.reception_date ? voucher.reception_date : ""
      );
      formData.set(
        "voucher[" + i + "][voucher_date]",
        voucher.voucher_date ? voucher.voucher_date : ""
      );
      formData.set("voucher[" + i + "][all_tasks]", 1);
      formData.set("voucher[" + i + "][work_order_task_id]", "");
      formData.set(
        "voucher[" + i + "][voucher_total_s_iva_price]",
        voucher.voucher_total_s_iva_price
          ? voucher.voucher_total_s_iva_price
          : 0
      );
      //		    formData.set("voucher["+i+"][iva_buy_id]", (voucher.iva_buy_id) ? voucher.iva_buy_id : '');
      //		    formData.set("voucher["+i+"][iva_sell_id]", (voucher.iva_sell_id) ? voucher.iva_sell_id : '');
    } else {
      voucher.tasks.map((val, idx) => {
        if (val.checked) {
          formData.set(
            "voucher[" + i + "][voucher_total_s_iva_price]",
            voucher.voucher_total_s_iva_price
              ? voucher.voucher_total_s_iva_price
              : 0
          );
          formData.set(
            "voucher[" + i + "][hansa_voucher_confirmed]",
            voucher.hansa_voucher_confirmed ? 1 : 0
          );
          formData.set(
            "voucher[" + i + "][work_order_id]",
            this.props.work_order.id
          );
          formData.set(
            "voucher[" + i + "][voucher_type_id]",
            voucher.voucher_type_id
          );
          formData.set(
            "voucher[" + i + "][number]",
            voucher.number ? voucher.number : ""
          );
          formData.set(
            "voucher[" + i + "][budget_id]",
            voucher.budget_id ? voucher.budget_id : ""
          );
          formData.set(
            "voucher[" + i + "][contact_id]",
            providers[0].contact_id
          );
          formData.set(
            "voucher[" + i + "][workforce_s_iva_price]",
            val.workforce_s_iva_price
          );
          formData.set(
            "voucher[" + i + "][materials_s_iva_price]",
            val.materials_s_iva_price
          );
          formData.set(
            "voucher[" + i + "][total_s_iva_price]",
            val.total_s_iva_price
          );
          formData.set(
            "voucher[" + i + "][voucher_total_s_iva_price]",
            voucher.voucher_total_s_iva_price
              ? voucher.voucher_total_s_iva_price
              : 0
          );
          formData.set(
            "voucher[" + i + "][due_date]",
            voucher.due_date ? voucher.due_date : ""
          );
          formData.set(
            "voucher[" + i + "][reception_date]",
            voucher.reception_date ? voucher.reception_date : ""
          );
          formData.set(
            "voucher[" + i + "][voucher_date]",
            voucher.voucher_date ? voucher.voucher_date : ""
          );
          formData.set("voucher[" + i + "][all_tasks]", 0);
          formData.set(
            "voucher[" + i + "][work_order_task_id]",
            val.id ? val.id : val.work_order_task_id
          );
          formData.set(
            "voucher[" + i + "][iva_buy_id]",
            val.iva_buy_id ? val.iva_buy_id : ""
          );
          formData.set(
            "voucher[" + i + "][provider_document_number]",
            voucher.provider_document_number
              ? voucher.provider_document_number
              : ""
          );
          if (this.props.can_change_payment_deadline) {
            if (
              parseInt(this.state.provider_payment_deal) !==
              parseInt(this.state.payment_deal)
            ) {
              formData.set(
                "voucher[" + i + "][custom_due_date]",
                voucher.due_date ? voucher.due_date : ""
              );
              formData.set(
                "voucher[" + i + "][custom_payment_deal]",
                this.state.payment_deal_hansa_code
                  ? this.state.payment_deal_hansa_code
                  : ""
              );
            }
          }
          if (
            this.state.voucher_realted &&
            this.state.voucher_realted.hansa_code
          ) {
            //						formData.set("voucher["+i+"][hansa_code]", this.state.voucher_realted.hansa_code);
          }
          //formData.set("voucher["+i+"][iva_sell_id]", (val.iva_sell_id) ? val.iva_sell_id : '');
          i++;
        }
      });
    }
    i = 0;
    if (this.state.files) {
      this.state.files.map((val, idx) => {
        if (val.file !== "" && val.file !== undefined) {
          formData.append("media[" + i + "][file]", val.file[0]);
          i++;
        }
      });
    }
    let self = this;
    const token = localStorage.getItem("userToken");
    if (voucher.id) {
      formData.set("_method", "PATCH");
      formData.set("voucher[0][id]", voucher.id);
      axios
        .post(api.vouchers().patch(voucher.id), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        })
        .then(response => {
          var snackbar = this.state.snackbar;
          snackbar.open = true;
          snackbar.severity = "success";
          snackbar.success_message = "Comprobante modificado con éxito";
          this.setState({ snackbar: snackbar });
          this.handleDialog(e);
          this.props.onUpdateWorkOrderState();
          this.setState({ saving: false });
        })
        .catch(function(error) {
          var error_message = "";
          var errors = error.response.data;
          if (errors.errors) {
            if (errors.errors.status_code !== 404) {
              var keys = Object.keys(errors.errors);
              for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                var key_errors = errors.errors[key];
                key_errors.map((val, idx) => {
                  error_message = error_message.concat(val).concat(" ");
                });
              }
            } else {
              error_message =
                "Ha ocurrido un error. Contacte a su administrador";
            }
          } else {
            error_message = "Ha ocurrido un error. Contacte a su administrador";
          }

          var snackbar = {
            open: true,
            success_message: error_message,
            severity: "error"
          };
          self.setState({ snackbar: snackbar });
          self.setState({ saving: false });
        });
    } else {
      axios
        .post(api.vouchers().post(), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        })
        .then(response => {
          var snackbar = this.state.snackbar;
          snackbar.open = true;
          snackbar.severity = "success";
          snackbar.success_message = "Comprobante cargado con éxito";
          this.setState({ snackbar: snackbar });
          this.handleDialog(e);
          this.props.onUpdateWorkOrderState();
          this.setState({ saving: false });
        })
        .catch(function(error) {
          var error_message = "";
          var errors = error.response.data;
          if (errors.errors) {
            if (errors.errors.status_code !== 404) {
              var keys = Object.keys(errors.errors);
              for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                var key_errors = errors.errors[key];
                key_errors.map((val, idx) => {
                  error_message = error_message.concat(val).concat(" ");
                });
              }
            } else {
              error_message =
                "Ha ocurrido un error. Contacte a su administrador";
            }
          } else {
            error_message = "Ha ocurrido un error. Contacte a su administrador";
          }

          var snackbar = {
            open: true,
            success_message: error_message,
            severity: "error"
          };
          self.setState({ snackbar: snackbar });
          self.setState({ saving: false });
        });
    }
  };

  handleUploadFile = (file, meta_data) => {
    var files_state = this.state.files;
    var file = { file: file, meta_data: meta_data };
    files_state.push(file);
    this.setState({ files: files_state });
  };

  handleChange = e => {
    if (e.target.name === "reject_reason") {
      var reject_dialog = this.state.reject_dialog;
      reject_dialog.reject_reason = e.target.value;
      this.setState({ reject_dialog: reject_dialog });
      return;
    }
    var voucher = this.state.voucher;
    var payment_days_value = this.state.payment_deal
      ? this.state.payment_deal
      : 0;

    if (e.target.name === "voucher_date" || e.target.name === "payment_deal") {
      if (e.target.name === "payment_deal") {
        this.setState({ payment_deal_hansa_code: e.target.value });
        var hansa_payment_deal = this.state.payment_deals.filter(
          p => p.hansa_code === e.target.value
        )[0];

        this.setState({ payment_deal: hansa_payment_deal.days_value });
        payment_days_value = hansa_payment_deal.days_value;
      }
      if (e.target.name === "voucher_date") {
        voucher.voucher_date = e.target.value;
      }
      //var payment_days_value = (this.state.providers[0]) ? (this.state.providers[0].payment_deal) ? this.state.providers[0].payment_deal : 0 : 0
      var due_date = "";
      if (payment_days_value >= 0 && payment_days_value !== "") {
        due_date = new Date(voucher.voucher_date);

        if (due_date) {
          due_date.setDate(due_date.getDate() + payment_days_value);
          if (!isNaN(due_date.getTime())) {
            voucher.due_date = due_date.toISOString().slice(0, 10);
          }
        }
      }
    } else if (e.target.name === "voucher_total_s_iva_price") {
      voucher.voucher_total_s_iva_price = e.target.value.replace("$", "");
    } else if (e.target.name === "hansa_voucher_confirmed") {
      voucher.hansa_voucher_confirmed = e.target.checked;
    } else {
      voucher[e.target.name] = e.target.value;
    }
    this.setState({ voucher: voucher });
  };

  autcompleteNumber = e => {
    var voucher = this.state.voucher;
    var voucher_number = voucher.number.split("-");
    if (voucher_number.length === 3) {
      voucher_number[0] = voucher_number[0].toUpperCase();
      voucher_number[1] = voucher_number[1].replaceAll("_", "");
      voucher_number[2] = voucher_number[2].replaceAll("_", "");
      if (voucher_number[1].length > 0) {
        voucher_number[1] = voucher_number[1].padStart(4, "0");
      }
      if (voucher_number[2].length > 0) {
        voucher_number[2] = voucher_number[2].padStart(8, "0");
      }
      voucher.number = voucher_number.join("-");
      this.setState({ voucher: voucher });
      this.getVoucherByNumber(voucher.number);
    }
  };

  handleTaskChange = e => {
    var voucher = this.state.voucher;
    var element = e.target.name.split(".");
    var key = element[0];
    var id = element[1];
    if (key === "checked") {
      voucher.tasks[id]["checked"] = e.target.checked;
    } else {
      voucher.tasks[id][key] = e.target.value.replace("$", "");
    }
    this.setState({ voucher: voucher });
    this.doSubtotals();
  };

  doSubtotals = () => {
    var subtotals = { materials: 0, workforce: 0, total: 0 };
    var voucher = this.state.voucher;
    //		var voucher_related = this.state.voucher_related
    for (var i = 0; i < voucher.tasks.length; i++) {
      if (voucher.tasks[i].checked === true) {
        voucher.tasks[i].materials_s_iva_price =
          voucher.tasks[i].materials_s_iva_price !== null
            ? voucher.tasks[i].materials_s_iva_price
            : 0;
        voucher.tasks[i].workforce_s_iva_price =
          voucher.tasks[i].workforce_s_iva_price !== null
            ? voucher.tasks[i].workforce_s_iva_price
            : 0;
        voucher.tasks[i].total_s_iva_price =
          voucher.tasks[i].total_s_iva_price !== null
            ? voucher.tasks[i].total_s_iva_price
            : 0;
        if (
          voucher.tasks[i].workforce_s_iva_price > 0 ||
          voucher.tasks[i].materials_s_iva_price > 0
        ) {
          subtotals.materials += voucher.tasks[i].materials_s_iva_price
            ? +parseFloat(voucher.tasks[i].materials_s_iva_price)
            : 0;
          subtotals.workforce += voucher.tasks[i].workforce_s_iva_price
            ? +parseFloat(voucher.tasks[i].workforce_s_iva_price)
            : 0;
          voucher.tasks[i].total_s_iva_price =
            +parseFloat(voucher.tasks[i].workforce_s_iva_price) +
            +parseFloat(voucher.tasks[i].materials_s_iva_price);
        } else {
          voucher.tasks[i].total_s_iva_price = +parseFloat(
            voucher.tasks[i].total_s_iva_price
          );
        }
        voucher.tasks[i].total_s_iva_price = Number(
          voucher.tasks[i].total_s_iva_price.toFixed(2)
        );
        subtotals.total += +parseFloat(voucher.tasks[i].total_s_iva_price);
        //				voucher_related.total_s_iva_price = +parseFloat(voucher.tasks[i].total_s_iva_price);
        //				voucher_related.total_s_iva_price = Number((voucher_related.total_s_iva_price).toFixed(2));
      }
    }
    voucher.subtotals = subtotals;
    this.setState({ voucher: voucher });
    //		this.setState({voucher_related:voucher_related})
  };

  handleAllTasksChange = e => {
    var voucher = this.state.voucher;
    voucher.all_tasks = e.target.checked;
    voucher.tasks.map((val, idx) => {
      voucher.tasks[idx].checked = e.target.checked;
    });
    this.setState({ voucher: voucher });
    this.doSubtotals();
  };
  getMediaUrl = async id => {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(api.media_path + "/" + id, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        return res.data;
      })
      .catch(err => {
        console.log(err);
      });
  };

  handleRejectDialog = voucher_id => {
    var reject_dialog = this.state.reject_dialog;
    reject_dialog.open = !reject_dialog.open;
    reject_dialog.voucher_id = voucher_id;
    this.setState({ reject_dialog: reject_dialog });
  };
  handleRejectVoucher = e => {
    this.setState({ saving: true });
    e.preventDefault();
    var formData = new FormData();
    formData.set("id", this.state.reject_dialog.voucher_id);
    formData.set("reject_reason", this.state.reject_dialog.reject_reason);
    const token = localStorage.getItem("userToken");
    var self = this;
    axios
      .post(api.vouchers().reject(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        var snackbar = this.state.snackbar;
        snackbar.open = true;
        snackbar.success_message = "Comprobante rechazado con éxito";
        snackbar.severity = "success";
        this.getVouchers(this.props.work_order.id);
        this.props.onUpdateWorkOrderState();
        this.setState({ snackbar: snackbar, saving: false });
        this.handleRejectDialog("");
      })
      .catch(function(error) {
        var snackbar = self.state.snackbar;
        snackbar.open = true;
        snackbar.success_message =
          "Ha ocurrido un error al rechazar el comprobante";
        snackbar.severity = "error";
        self.getVouchers(self.props.work_order.id);
        self.props.onUpdateWorkOrderState();
        self.setState({ snackbar: snackbar, saving: false });
        self.handleRejectDialog("");
      });
  };
  render() {
    const classes = this.props.classes;
    var payment_deal = this.state.payment_deal ? this.state.payment_deal : 0;
    const iva_conditions = this.props.iva_conditions;
    return (
      <React.Fragment>
        <Snackbar
          open={this.state.snackbar.open}
          onClose={this.handleSnackbar}
          className="alert-fix"
        >
          <Alert
            onClose={this.handleSnackbar}
            severity={this.state.snackbar.severity}
          >
            {this.state.snackbar.success_message}
          </Alert>
        </Snackbar>
        <Dialog
          open={this.state.reject_dialog.open}
          onClose={() => {
            this.handleRejectDialog("");
          }}
        >
          <DialogTitle id="alert-dialog-title">
            {"Rechazar comprobante"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              ¿Está seguro que desea rechazar el comprobante?
            </DialogContentText>
            <TextField
              id="reject_reason"
              value={this.state.reject_dialog.reject_reason}
              label="Motivo"
              onChange={this.handleChange}
              type="text"
              required
              name="reject_reason"
              margin="normal"
              className="m-0 p-0 w-full"
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{ style: { minWidth: 400, fontSize: "0.75rem" } }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.handleRejectDialog("");
              }}
              color="primary"
            >
              Cancelar
            </Button>
            <Button
              onClick={this.handleRejectVoucher}
              color="primary"
              autoFocus
            >
              Rechazar
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          fullScreen
          open={this.state.dialog.open}
          onClose={this.handleDialog}
          TransitionComponent={Transition}
        >
          <React.Fragment>
            <AppBar className={classes.appBar}>
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={this.handleDialog}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6" className={classes.title}>
                  Agregar comprobante
                </Typography>
              </Toolbar>
            </AppBar>
            <div className="row mt-2 ml-2">
              <div className="">
                {/*<TextField
									id="number"
									value={this.state.voucher.number}
//									label="Numero de factura"
									onChange={this.handleChange}
									type="text"
									required
									name="number"
									margin="normal"
									className="m-0 p-0 mr-2 mt-2"
									InputLabelProps={{
										shrink: true
									}}	
						          	InputProps={{
							            startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 100}}>Nro factura</Typography></InputAdornment>,
									}}
									inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}}
								/>*/}
                {this.state.voucher_realted && this.state.voucher_realted.id ? (
                  <React.Fragment>
                    <TextField
                      id="hansa_code"
                      value={this.state.voucher_realted.hansa_code}
                      //									label="Numero de factura"
                      type="text"
                      disabled
                      name="hansa_code"
                      margin="normal"
                      className="m-0 p-0 mr-2 mt-2"
                      InputLabelProps={{
                        shrink: true
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography
                              variant="caption"
                              style={{ width: 100 }}
                            >
                              Cod. Hansa
                            </Typography>
                          </InputAdornment>
                        )
                      }}
                      inputProps={{
                        style: { minWidth: 70, width: 70, fontSize: "0.75rem" }
                      }}
                    />
                    <NumberFormat
                      id={"voucher_total_s_iva_price"}
                      name={"voucher_total_s_iva_price"}
                      value={this.state.voucher.voucher_total_s_iva_price}
                      placeholder="Ingrese el total de factuar"
                      //disabled={true}
                      onChange={this.handleChange}
                      className="m-0 p-0 mt-2 mr-1"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography
                              variant="caption"
                              style={{ width: 120 }}
                            >
                              Total de la factura
                            </Typography>
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <Checkbox
                            id="hansa_voucher_confirmed"
                            name="hansa_voucher_confirmed"
                            className={classes.checkbox}
                            onChange={this.handleChange}
                            value={this.state.voucher.hansa_voucher_confirmed}
                            checked={this.state.voucher.hansa_voucher_confirmed}
                            color="primary"
                            inputProps={{ "aria-label": "secondary checkbox" }}
                          />
                        ),
                        style: {
                          minWidth: 250,
                          width: 250,
                          fontSize: "0.75rem"
                        }
                      }}
                      disabled={!this.state.voucher.can_edit ? true : false}
                      decimalSeparator="."
                      prefix={"$"}
                      customInput={TextField}
                      InputLabelProps={{
                        shrink: true
                      }}
                      isAllowed={values => {
                        let { floatValue } = values;
                        floatValue = floatValue !== undefined ? floatValue : 0;
                        return floatValue >= 0 && floatValue < 99999999;
                      }}
                    />
                  </React.Fragment>
                ) : (
                  ""
                )}
                {this.state.voucher.voucher_type_id === "" ||
                parseInt(this.state.voucher.voucher_type_id) === 1 ? (
                  <Input
                    id="number"
                    name="number"
                    label="Nro factura"
                    value={this.state.voucher.number}
                    disabled={!this.state.voucher.can_edit ? true : false}
                    onChange={this.handleChange}
                    placeholder="Ingrese nro factura"
                    margin="normal"
                    className="m-0 p-0 mr-2 mt-2"
                    inputProps={{
                      style: { minWidth: 100, fontSize: "0.75rem" }
                    }}
                    inputComponent={TextMaskCustom}
                    startAdornment={
                      <Typography variant="caption" style={{ width: 100 }}>
                        Nro factura
                      </Typography>
                    }
                    onBlur={this.autcompleteNumber}
                  />
                ) : (
                  <TextField
                    id="number"
                    value={this.state.voucher.number}
                    //									label="Numero de factura"
                    onChange={this.handleChange}
                    type="text"
                    required
                    name="number"
                    disabled={!this.state.voucher.can_edit ? true : false}
                    margin="normal"
                    className="m-0 p-0 mr-2 mt-2"
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption" style={{ width: 100 }}>
                            Nro comprobante
                          </Typography>
                        </InputAdornment>
                      )
                    }}
                    inputProps={{
                      style: { minWidth: 200, fontSize: "0.75rem" }
                    }}
                  />
                )}
                {/*<Input
									id="number"
									name="number"
									label="Nro factura"
									value={this.state.voucher.number}
									disabled={(this.state.voucher.id > 0) ? true : false }
									onChange={this.handleChange}
									placeholder="Ingrese nro factura"
									margin="normal"
									className="m-0 p-0 mr-2 mt-2"
									inputProps={{style:{minWidth: 100, fontSize: '0.75rem'}}} 
									inputComponent={TextMaskCustom}
									startAdornment={<Typography variant="caption" style={{width: 100}}>Nro factura</Typography>}
									onBlur={this.autcompleteNumber}
							/>*/}

                <TextField
                  id="voucher_type_id"
                  name="voucher_type_id"
                  select
                  disabled={!this.state.voucher.can_edit ? true : false}
                  margin="normal"
                  className={classes.select}
                  InputLabelProps={{
                    shrink: true
                  }}
                  onChange={this.handleChange}
                  value={this.state.voucher.voucher_type_id}
                  inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption" style={{ width: 140 }}>
                          Tipo de Comprobante
                        </Typography>
                      </InputAdornment>
                    ),
                    style: { fontSize: "0.75rem" }
                  }}
                >
                  {this.state.voucher_types.map(option => (
                    <MenuItem
                      key={option.id}
                      value={option.id}
                      className={classes.typography}
                    >
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>

                {/*
								<TextField
									id="cae"
									value={this.state.voucher.cae}
									label="CAE"
									onChange={this.handleChange}
									type="text"
									required
									name="cae"
									margin="normal"
									className="m-0 p-0 mr-2 mt-1"
									InputLabelProps={{
										shrink: true,
							            startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 100}}>CAE</Typography></InputAdornment>,

									}}
									inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}}
								/> */}

                {this.state.voucher.id > 0 ? (
                  <TextField
                    id="contact_id"
                    name="contact_id"
                    type="text"
                    disabled
                    margin="normal"
                    className={classes.select}
                    InputLabelProps={{
                      shrink: true
                    }}
                    onChange={this.handleChange}
                    value={this.state.voucher.contact.business_name}
                    inputProps={{
                      style: { minWidth: 70, fontSize: "0.75rem" }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption" style={{ width: 65 }}>
                            Proveedor
                          </Typography>
                        </InputAdornment>
                      ),
                      style: { fontSize: "0.75rem" }
                    }}
                  />
                ) : this.state.providers.length > 0 ? (
                  <TextField
                    id="contact_id"
                    name="contact_id"
                    select
                    margin="normal"
                    className={classes.select}
                    InputLabelProps={{
                      shrink: true
                    }}
                    onChange={this.handleChange}
                    value={this.state.voucher.contact_id}
                    inputProps={{
                      style: { minWidth: 70, fontSize: "0.75rem" }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption" style={{ width: 100 }}>
                            Proveedor
                          </Typography>
                        </InputAdornment>
                      ),
                      style: { fontSize: "0.75rem" }
                    }}
                  >
                    {this.state.providers.map(option => (
                      <MenuItem
                        key={option.contact_id}
                        value={option.contact_id}
                        className={classes.typography}
                      >
                        {option.business_name}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : (
                  ""
                )}
                {this.state.voucher.id > 0 ? (
                  <TextField
                    id="budget_id"
                    name="budget_id"
                    type="text"
                    disabled
                    margin="normal"
                    className={classes.select}
                    InputLabelProps={{
                      shrink: true
                    }}
                    onChange={this.handleChange}
                    value={this.state.voucher.budget_id}
                    inputProps={{
                      style: { minWidth: 70, fontSize: "0.75rem" }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption" style={{ width: 75 }}>
                            Presupuesto
                          </Typography>
                        </InputAdornment>
                      ),
                      style: { fontSize: "0.75rem" }
                    }}
                  />
                ) : this.state.budgets.length > 0 ? (
                  <TextField
                    id="budget_id"
                    name="budget_id"
                    select
                    margin="normal"
                    className={classes.select}
                    InputLabelProps={{
                      shrink: true
                    }}
                    onChange={this.handleChange}
                    value={this.state.voucher.budget_id}
                    inputProps={{
                      style: { minWidth: 70, fontSize: "0.75rem" }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption" style={{ width: 75 }}>
                            Presupuesto
                          </Typography>
                        </InputAdornment>
                      ),
                      style: { fontSize: "0.75rem" }
                    }}
                  >
                    {this.state.budgets.map(option => (
                      <MenuItem
                        key={option.id}
                        value={option.id}
                        className={classes.typography}
                      >
                        {option.id}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : (
                  ""
                )}
                <TextField
                  id="provider_document_number"
                  name="provider_document_number"
                  type="text"
                  margin="normal"
                  className={classes.select}
                  InputLabelProps={{
                    shrink: true
                  }}
                  onChange={this.handleChange}
                  value={this.state.voucher.provider_document_number}
                  inputProps={{
                    style: { minWidth: 70, fontSize: "0.75rem" }
                  }}
                  placeholder="Ingrese CUIT"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption" style={{ width: 125 }}>
                          CUIT Proveedor
                        </Typography>
                      </InputAdornment>
                    ),
                    style: { fontSize: "0.75rem" }
                  }}
                />
              </div>
              <div>
                <TextField
                  id="reception_date"
                  value={this.state.voucher.reception_date}
                  onChange={this.handleChange}
                  type="date"
                  required
                  name="reception_date"
                  disabled={
                    !this.state.voucher.can_edit ||
                    this.state.voucher_realted.id > 0
                      ? true
                      : false
                  }
                  margin="normal"
                  className="m-0 p-0 mr-2 mt-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption" style={{ width: 120 }}>
                          Fecha de recepcion
                        </Typography>
                      </InputAdornment>
                    )
                  }}
                  inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
                />
                <TextField
                  id="voucher_date"
                  value={this.state.voucher.voucher_date}
                  onChange={this.handleChange}
                  type="date"
                  required
                  disabled={
                    !this.state.voucher.can_edit ||
                    this.state.voucher_realted.id > 0
                      ? true
                      : false
                  }
                  name="voucher_date"
                  margin="normal"
                  className="m-0 p-0 mr-2 mt-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption" style={{ width: 120 }}>
                          Fecha de factura
                        </Typography>
                      </InputAdornment>
                    )
                  }}
                  inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
                />
                <TextField
                  id="created_at"
                  value={this.state.voucher.created_at}
                  onChange={this.handleChange}
                  type="date"
                  required
                  disabled={
                    !this.state.voucher.can_edit ||
                    this.state.voucher_realted.id > 0
                      ? true
                      : false
                  }
                  name="created_at"
                  margin="normal"
                  className="m-0 p-0 mr-2 mt-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption" style={{ width: 120 }}>
                          Fecha de carga
                        </Typography>
                      </InputAdornment>
                    )
                  }}
                  inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
                />
                {!this.props.can_change_payment_deadline ? (
                  <TextField
                    id="payment_deal"
                    name="payment_deal"
                    margin="normal"
                    disabled
                    type="text"
                    className={classes.select}
                    InputLabelProps={{
                      shrink: true
                    }}
                    value={payment_deal}
                    inputProps={{ style: { fontSize: "0.75rem" } }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">
                            Termino de pago
                          </Typography>
                        </InputAdornment>
                      ),
                      style: { fontSize: "0.75rem" }
                    }}
                  />
                ) : (
                  <TextField
                    id="payment_deal"
                    name="payment_deal"
                    margin="normal"
                    select
                    type="text"
                    className={classes.select}
                    InputLabelProps={{
                      shrink: true
                    }}
                    disabled={!this.state.voucher.can_edit ? true : false}
                    onChange={this.handleChange}
                    value={
                      this.state.payment_deal_hansa_code
                        ? this.state.payment_deal_hansa_code
                        : ""
                    }
                    inputProps={{ style: { fontSize: "0.75rem" } }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">
                            Termino de pago
                          </Typography>
                        </InputAdornment>
                      ),
                      style: { fontSize: "0.75rem" }
                    }}
                  >
                    {this.state.payment_deals.map(option => {
                      if (!option.is_visible_in_vouchers) return;
                      return (
                        <MenuItem
                          key={option.id}
                          value={option.hansa_code}
                          className={classes.typography}
                        >
                          {option.hansa_code} - {option.name} -{" "}
                          {option.days_value}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                )}
                <TextField
                  id="payment_deal"
                  name="payment_deal"
                  margin="normal"
                  disabled
                  type="date"
                  className={classes.select}
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={this.state.voucher.due_date}
                  inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">
                          Fecha de vencimiento
                        </Typography>
                      </InputAdornment>
                    ),
                    style: { fontSize: "0.75rem" }
                  }}
                />

                {/*<TextField
									id="due_date"
									value={this.state.voucher.due_date}
									onChange={this.handleChange}
									type="date"
									required
									name="due_date"
									margin="normal"
									className="m-0 p-0 mr-2 mt-2"
									InputLabelProps={{
										shrink: true,
									}}
						          	InputProps={{
							            startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 130}}>Fecha de Vencimiento</Typography></InputAdornment>,
									}}
									inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}}
								/>*/}
                <div className="row">
                  <div className="col-md-6">
                    <Table
                      size="small"
                      aria-label="a dense table"
                      style={{ width: "auto", minWidth: "650px" }}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell
                            className={classes.tableCell}
                            style={{ fontWeight: "550" }}
                          >
                            {/*(this.state.work_order_tasks_count === this.state.voucher.tasks.length)
																	?
																		<Checkbox
																			name="all_tasks"
																			value={this.state.voucher.all_tasks}
																			onChange={this.handleAllTasksChange}
																		/>
																	:
																		''
																*/}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{ fontWeight: "550" }}
                          >
                            Tarea
                          </TableCell>
                          {/*									            <TableCell className={classes.tableCell} style={{fontWeight: '550'}} >Mano de obra</TableCell>
													<TableCell className={classes.tableCell} style={{fontWeight: '550'}} >Materiales</TableCell>
													<TableCell className={classes.tableCell} style={{fontWeight: '550'}} >Total</TableCell>
	*/}
                          <TableCell
                            className={classes.tableCell}
                            style={{ fontWeight: "550" }}
                          >
                            Mano de obra s/iva
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{ fontWeight: "550" }}
                          >
                            Repuestos s/iva
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{ fontWeight: "550" }}
                          >
                            Total s/iva
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{ fontWeight: "550" }}
                          >
                            IVA Compras
                          </TableCell>
                          {/*<TableCell className={classes.tableCell} style={{fontWeight: '550'}} >IVA Ventas</TableCell>*/}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.voucher.tasks.map((val, idx) => {
                          return (
                            <React.Fragment>
                              <TableRow>
                                <TableCell
                                  className={classes.tableCell}
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  {this.state.voucher.all_tasks ? (
                                    ""
                                  ) : (
                                    <Checkbox
                                      name={"checked." + idx}
                                      id={"checked." + idx}
                                      disabled={
                                        !this.state.voucher.can_edit
                                          ? true
                                          : false
                                      }
                                      checked={val.checked}
                                      onChange={this.handleTaskChange}
                                    />
                                  )}
                                </TableCell>
                                <TableCell
                                  className={classes.tableCell}
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  {val.task.name}
                                </TableCell>
                                {/*													<TableCell className={classes.tableCell} style={{fontSize: '0.75rem'}} >
															<NumberFormat 
																id={"workforce_price."+idx}
																name={"workforce_price."+idx}
																value={val.workforce_price}
																onChange={this.handleTaskChange}
																className="m-0 p-0"
																InputProps={{style: {minWidth: 70,fontSize: '0.75rem'}}}
																decimalSeparator='.'
																prefix={'$'}
																customInput={TextField}  
																InputLabelProps={{
																shrink: true,
																}}
																isAllowed={(values) => {
																const {floatValue} = values;
																return floatValue >= 0 && floatValue < 99999999;
																}}            
																/>								          
														</TableCell>	
														<TableCell className={classes.tableCell} style={{fontSize: '0.75rem'}} >
															<NumberFormat 
																id={"materials_price."+idx}
																name={"materials_price."+idx}
																value={val.materials_price}
																onChange={this.handleTaskChange}
																className="m-0 p-0"
																InputProps={{style: {minWidth: 70,fontSize: '0.75rem'}}}
																decimalSeparator='.'
																prefix={'$'}
																customInput={TextField}  
																InputLabelProps={{
																shrink: true,
																}}
																isAllowed={(values) => {
																const {floatValue} = values;
																return floatValue >= 0 && floatValue < 99999999;
																}}            
																/>								          
														</TableCell>	
														<TableCell className={classes.tableCell} style={{fontSize: '0.75rem'}} >
															<NumberFormat 
																id={"total_price."+idx}
																name={"total_price."+idx}
																value={val.total_price}
																onChange={this.handleTaskChange}
																className="m-0 p-0"
																InputProps={{style: {minWidth: 70,fontSize: '0.75rem'}}}
																decimalSeparator='.'
																prefix={'$'}
																customInput={TextField}  
																InputLabelProps={{
																shrink: true,
																}}
																isAllowed={(values) => {
																const {floatValue} = values;
																return floatValue >= 0 && floatValue < 99999999;
																}}            
																/>								          
														</TableCell>	
													*/}
                                <TableCell
                                  className={classes.tableCell}
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  <NumberFormat
                                    id={"workforce_s_iva_price." + idx}
                                    name={"workforce_s_iva_price." + idx}
                                    value={val.workforce_s_iva_price}
                                    placeholder="Ingrese la mano de obra"
                                    onChange={this.handleTaskChange}
                                    className="m-0 p-0"
                                    InputProps={{
                                      style: {
                                        minWidth: 70,
                                        fontSize: "0.75rem"
                                      }
                                    }}
                                    disabled={
                                      !this.state.voucher.can_edit ||
                                      !val.task.workforce_account_cost
                                        ? true
                                        : false
                                    }
                                    decimalSeparator="."
                                    prefix={"$"}
                                    customInput={TextField}
                                    InputLabelProps={{
                                      shrink: true
                                    }}
                                    isAllowed={values => {
                                      let { floatValue } = values;
                                      floatValue =
                                        floatValue !== undefined
                                          ? floatValue
                                          : 0;
                                      return (
                                        floatValue >= 0 && floatValue < 99999999
                                      );
                                    }}
                                  />
                                </TableCell>
                                <TableCell
                                  className={classes.tableCell}
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  <NumberFormat
                                    id={"materials_s_iva_price." + idx}
                                    name={"materials_s_iva_price." + idx}
                                    value={val.materials_s_iva_price}
                                    placeholder="Ingrese los materiales"
                                    onChange={this.handleTaskChange}
                                    className="m-0 p-0"
                                    InputProps={{
                                      style: {
                                        minWidth: 70,
                                        fontSize: "0.75rem"
                                      }
                                    }}
                                    disabled={
                                      !this.state.voucher.can_edit ||
                                      !val.task.materials_account_cost
                                        ? true
                                        : false
                                    }
                                    decimalSeparator="."
                                    prefix={"$"}
                                    customInput={TextField}
                                    InputLabelProps={{
                                      shrink: true
                                    }}
                                    isAllowed={values => {
                                      let { floatValue } = values;
                                      floatValue =
                                        floatValue !== undefined
                                          ? floatValue
                                          : 0;
                                      return (
                                        floatValue >= 0 && floatValue < 99999999
                                      );
                                    }}
                                  />
                                </TableCell>
                                <TableCell
                                  className={classes.tableCell}
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  <NumberFormat
                                    id={"total_s_iva_price." + idx}
                                    name={"total_s_iva_price." + idx}
                                    value={val.total_s_iva_price}
                                    placeholder="Ingrese el total"
                                    //disabled={true}
                                    onChange={this.handleTaskChange}
                                    className="m-0 p-0"
                                    InputProps={{
                                      style: {
                                        minWidth: 70,
                                        fontSize: "0.75rem"
                                      }
                                    }}
                                    disabled={
                                      !this.state.voucher.can_edit ||
                                      !val.task.total_account_cost
                                        ? true
                                        : false
                                    }
                                    decimalSeparator="."
                                    prefix={"$"}
                                    customInput={TextField}
                                    InputLabelProps={{
                                      shrink: true
                                    }}
                                    isAllowed={values => {
                                      let { floatValue } = values;
                                      floatValue =
                                        floatValue !== undefined
                                          ? floatValue
                                          : 0;
                                      return (
                                        floatValue >= 0 && floatValue < 99999999
                                      );
                                    }}
                                  />
                                </TableCell>
                                <TableCell className={classes.tableCell}>
                                  <Select
                                    native
                                    name={"iva_buy_id." + idx}
                                    inputProps={{
                                      name: "iva_buy_id." + idx,
                                      className: "iva_buy_id." + idx
                                    }}
                                    value={val.iva_buy_id}
                                    style={{ fontSize: "0.75rem", width: 70 }}
                                    disabled={
                                      !this.state.voucher.can_edit
                                        ? true
                                        : false
                                    }
                                    onChange={this.handleTaskChange}
                                    required
                                    input={
                                      <Input
                                        id="grouped-native-select"
                                        name="contract_id"
                                      />
                                    }
                                  >
                                    <option value="" />
                                    {iva_conditions.buy.map(condition => (
                                      <option
                                        id={condition.name}
                                        value={condition.id}
                                      >
                                        {condition.name}
                                      </option>
                                    ))}
                                  </Select>
                                </TableCell>
                                {/*<TableCell className={classes.tableCell}>
															<Select native name={"iva_sell_id."+idx}
																inputProps={{
																name:"iva_sell_id."+idx,
																className:"iva_sell_id."+idx
																}}
																value={val.iva_sell_id}
																style={{fontSize: '0.75rem', width: 70}}
																onChange={this.handleTaskChange}
																required
																input={<Input id="grouped-native-select" name='contract_id'/>}>
																<option value="" />
																{iva_conditions.sell.map((condition) => <option id={condition.name} value={condition.id}>{condition.name}
															</option>)}
															</Select>
														</TableCell>
														*/}
                              </TableRow>
                            </React.Fragment>
                          );
                        })}
                      </TableBody>
                    </Table>
                    <div className="row mt-2 ml-4">
                      <MediaFile
                        onChange={this.handleUploadFile}
                        title="Agregar comprobante"
                        width={"15rem"}
                        height={"2rem"}
                        meta_data="comprobante"
                        acceptedFiles={[".pdf"]}
                      />
                      {this.state.voucher.id > 0 ? (
                        this.state.voucher.media.length > 0 ? (
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            style={{ fontSize: "0.75rem", marginRight: "8px" }}
                            onClick={e => {
                              window.open(
                                api.media_download +
                                  "/" +
                                  this.state.voucher.media[0].id,
                                "_blank"
                              );
                            }}
                          >
                            Descargar
                          </Button>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                      <Button
                        disabled={
                          this.state.action === "view" || this.state.saving
                            ? true
                            : false
                        }
                        variant="contained"
                        color="primary"
                        size="small"
                        style={{ fontSize: "0.75rem" }}
                        onClick={this.handleSubmit}
                      >
                        Guardar
                      </Button>
                      <Button
                        disabled={this.state.action !== "view" ? false : true}
                        variant="contained"
                        color="primary"
                        size="small"
                        style={{ fontSize: "0.75rem", marginLeft: "8px" }}
                        onClick={() =>
                          window.open(
                            "/cuit-verification/" +
                              this.state.voucher.contact_id,
                            "_blank"
                          )
                        }
                      >
                        Verificar CUIT
                      </Button>
                    </div>
                  </div>
                  <div className="col-md-5">
                    {this.state.files[0] && (
                      <embed
                        src={
                          URL.createObjectURL(this.state.files[0].file[0]) +
                          "#toolbar=0&navpanes=0&scrollbar=0"
                        }
                        width="100%"
                        height="600"
                        type="application/pdf"
                      />
                    )}
                    {this.state.voucher.media_url && (
                      <embed
                        src={
                          this.state.voucher.media_url +
                          "#toolbar=0&navpanes=0&scrollbar=0"
                        }
                        width="100%"
                        height="600"
                        type="application/pdf"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        </Dialog>
        <Typography variant="body1" className="my-2">FC Compra</Typography>
        <Typography variant="caption">
          <Table
            size="small"
            aria-label="a dense table"
            style={{ width: "auto", minWidth: "650px" }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                  # SAP / Hansa
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                  Tipo de comprobante
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                  Estado
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                  Tarea
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                  Razón social
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                  Numero
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                  Fecha de alta
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                  Fecha factura
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                  Fecha de pago
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                  Total
                </TableCell>
                {/*<TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                  &nbsp;
                </TableCell>*/}
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.vouchers.map((val, idx) => {
                var options =
                  val.media.length > 0
                    ? [{ name: "Aprobar" }, { name: "Editar" }, { name: "Ver" }]
                    : [
                        { name: "Aprobar" },
                        { name: "Editar" },
                        { name: "Ver" }
                      ];
                var show_alert = false;
                if (!this.props.can_edit) {
                  options.splice(0, 1);
                }
                if (
                  val.state === "ENTREGADO" ||
                  val.state === "PENDIENTE APROBAR" ||
                  val.state === "PENDIENTE VALIDACION"
                ) {
                  show_alert = true;
                }
                if (
                  val.state !== "ENTREGADO" &&
                  val.state !== "PENDIENTE APROBAR" &&
                  val.state !== "PENDIENTE VALIDACION"
                ) {
                  options =
                    val.media.length > 0
                      ? [
                          { name: "Ver" },
                          { name: "Descargar" },
                          { name: "Adjuntar en Hansa" }
                        ]
                      : [{ name: "Ver" }, { name: "Adjuntar Comprobante" }];
                }
                if (val.can_cancel && !val.is_provider_voucher) {
                  options.push({ name: "Eliminar" });
                }
                if (val.can_cancel && val.is_provider_voucher) {
                  options.push({ name: "Rechazar" });
                }
                if (val.state === "RECHAZADO") {
                  options = [{ name: "Ver" }];
                }
                options = [{ name: "Descargar" }];
                return (
                  <TableRow
                    key={idx}
                    style={{ border: show_alert ? "2px solid red" : "" }}
                  >
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontSize: "0.75rem" }}
                    >
                      {val.hansa_code}
                      {val.sap_code}
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontSize: "0.75rem" }}
                    >
                      {val.type}
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontSize: "0.75rem" }}
                    >
                      {show_alert ? (
                        <i class="text-danger font-weight-bold material-icons">
                          warning
                        </i>
                      ) : (
                        ""
                      )}{" "}
                      {val.state}
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontSize: "0.75rem" }}
                    >
                      {val.work_order_task.name}
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontSize: "0.75rem" }}
                    >
                      {val.contact.business_name}
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontSize: "0.75rem" }}
                    >
                      {val.number}
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontSize: "0.75rem" }}
                    >
                      {val.created_at}
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontSize: "0.75rem" }}
                    >
                      {val.voucher_date}
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontSize: "0.75rem" }}
                    >
                      {val.payment_date}
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontSize: "0.75rem" }}
                    >
                      ${val.total_s_iva_price}
                    </TableCell>
                    <TableCell>
                      <MenuActions
                        id={idx}
                        options={options}
                        handleAction={this.handleMenuAction}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Typography>
        {/*this.state.voucher.tasks.length > 0 && !this.props.disabled ? (
          this.state.budgets.length > 0 ? (
            <div className="row mt-2 ml-4">
              <Button
                className="mt-3"
                variant="contained"
                color="primary"
                size="small"
                style={{ fontSize: "0.75rem" }}
                onClick={e => {
                  this.handleDialog(e);
                }}
              >
                Cargar comprobante
              </Button>
            </div>
          ) : (
            <div className="row mt-2 ml-4">
              Falta cargar presupuesto o asignar un proveedor.
            </div>
          )
        ) : (
          ""
        )*/}
      </React.Fragment>
    );
  }
}

export default withStyles(useStyles)(Vouchers);
